import { render, staticRenderFns } from "./QuoteSummary.vue?vue&type=template&id=54104874&scoped=true"
import script from "./QuoteSummary.vue?vue&type=script&lang=js"
export * from "./QuoteSummary.vue?vue&type=script&lang=js"
import style0 from "./QuoteSummary.vue?vue&type=style&index=0&id=54104874&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54104874",
  null
  
)

export default component.exports